import { STORE_GETTER } from "../store/store";
import { USER_STORE_ACTION, USER_STORE_GETTER } from "../store/user-store";




export const userMixin = {

	computed: {

		isLoggedIn() {
			return this.$store.getters[STORE_GETTER.IS_LOGGED_IN];
		},

		currentOrder() {
			return this.$store.getters[USER_STORE_GETTER.CURRENT_ORDER];
		},

		currentOrderId() {
			return this.$store.getters[USER_STORE_GETTER.CURRENT_ORDER_ID];
		},

		orderList() {
			const list = this.$store.getters[USER_STORE_GETTER.GET_ORDER_LIST]; // ej indexerad

			if (list){
				return list.filter(order => order != null).sort((a, b) => {
					if (a.orderStatus?.status == b.orderStatus?.status){
						return b.orderStatusDate.localeCompare(a.orderStatusDate)
					}else{
						return a.orderStatus?.status - b.orderStatus?.status
					}
				})
			}

			return list;
		},



		customerList() {
			return this.$store.getters[USER_STORE_GETTER.GET_CUSTOMER_LIST];
		},

		userModel() {
			return this.$store.getters[USER_STORE_GETTER.USER_MODEL];
		},

		orderListLength() {
				return this.$store.getters[USER_STORE_GETTER.GET_ORDER_LIST_INDEXED]?.filter(order => order != null)?.length; //  FP: 2026 ändrade till != (!==)

		},

		orderStatusList(){
			return [{ key: "PRELIMINARY", status: 10, label: "Premiliminär" }, { key: "ORDERED", status: 20, label: "Beställd" }, { key: "RECIVED", status: 30, label: "Mottagen" }]
			
		},

		orderStatusPreliminary(){
			return this.orderStatusList.find(orderStatus => orderStatus.status == 10);
		},

		orderStatusSent() {
			return this.orderStatusList.find(orderStatus => orderStatus.status == 20);
		},

		orderStatusRecived() {
			return this.orderStatusList.find(orderStatus => orderStatus.status == 30);
		},


	},

	methods: {

		showDeliveryTimeForProduct(product){

			return product?.noInStockKey == "OUT_OF_STOCK";

		},

		showDeliveryTimeForProductOptionSet(product){

			if (product && product.details?.productOptionSetList){

				return product?.details?.productOptionSetList?.find(productOptionSet => productOptionSet.noInStockKey == 'OUT_OF_STOCK' ) != null

			}

			return false



		},

		productHasProductOptions(product){

			return product?.productOptionData?.count > 0
		},

		noInStockLabel(key){

			if (key == "OUT_OF_STOCK"){
				return "Slut på lager"
			}

			if (key == "LOW_STOCK") {
				return "Få på lager"
			}

			if (key == "SOME_IN_STOCK") {
				return "Vissa finns på lager"
			}

			return "Finns i lager";

		},
		noInStockLabelShort(key) {

			if (key == "OUT_OF_STOCK") {
				return "Slut"
			}

			if (key == "LOW_STOCK") {
				return "Fåtal"
			}

			if (key == "SOME_IN_STOCK") {
				return "Vissa i lager"
			}

			return "I lager";

		},
		noInStockSymbol(key) {

			if (key == "OUT_OF_STOCK") {
				return "0"
			}

			if (key == "LOW_STOCK") {
				return "<5"
			}

			return "5+";

		},



		createOrder({dropship}) {


			this.$store.dispatch({ type: USER_STORE_ACTION.CREATE_ORDER, data: {} }).then((result) => {
				console.log('FP: result: ', result);

				if (result?.createdOrderId > 0 && dropship) {
					const order = this.orderList?.find(order => order != null && order.orderId == result.createdOrderId)
					if (order) {
						order.meta.dropship = true
					}

				}

			}).finally(() => {

			})
		},

	}
}



